module.exports = __webpack_public_path__ + "static/media/doorIndustrial.8f5bcda8.jpeg";